import React from 'react';
import '../css/policyprocesssteps.css';
import policyunderstandimg from '../assets/policyunderstandimg.webp';
import policyoptionsimg from '../assets/policyoptionsimg.webp';
import policyguidanceimg from '../assets/policyguidanceimg.webp';
import policydecisionimg from '../assets/policydecisionimg.webp';
import { Helmet } from 'react-helmet-async';

const PolicyProcessSteps = () => {
  return (
    <div className="process-section-container">
      <Helmet>
        <title>Life Insurance Advice | Choose The Right Policy Today | Policy Samjho</title>
        <meta
          name="description"
          content="Get expert life insurance advice tailored to your financial goals. Compare plans, understand benefits, and protect your family's future with Policy Samjho's guidance."
        />
        <meta
          name="keywords"
          content="life insurance advice India, best life insurance plans, term insurance guidance, life insurance policy comparison, personalized insurance consultation"
        />

        <link rel="canonical" href="https://policysamjho.com/life-insurance-advice/" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Life Insurance Advice",
            "description": "Expert consultation for choosing the right life insurance policy. Understand benefits and ensure financial protection with Policy Samjho guidance.",
            "provider": {
              "@type": "Organization",
              "name": "Policy Samjho",
              "url": "https://policysamjho.com/"
            },
            "serviceType": "Life Insurance Advice",
            "areaServed": "IN",
            "url": "https://policysamjho.com/life-insurance-advice/",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+91-9584484800",
              "email": "info@policysamjho.com",
              "contactType": "customer service"
            }
          })}
        </script>
      </Helmet>

      <p className="process-subtitle">
        <span className="process-arrows"></span> STEP-BY-STEP PROCESS <span className="process-arrows"></span>
      </p>

      <h2 className="process-title">Start Here - How It Works</h2>

      <div className="process-steps-flex-container">
        <div className="process-item item-1">
          <div className="circle-container">
            <span className="step-number">01</span>
            <img src={policyunderstandimg} alt="Understand Your Need Icon" className="step-icon" />
          </div>
          <h3 className="item-title">We Understand Your Need</h3>
          <p className="item-description">
            Tell us about your life goals, current policies, and budget.
          </p>
        </div>
        <div className="process-item item-2">
          <div className="circle-container">
            <span className="step-number">02</span>
            <img src={policyoptionsimg} alt="Policy Options Icon" className="step-icon" />
          </div>
          <h3 className="item-title">Learn About Policy Options in Easy Language</h3>
          <p className="item-description">
            Explore different policies explained in simple, easy-to-understand terms.
          </p>
        </div>
        <div className="process-item item-3">
          <div className="circle-container">
            <span className="step-number">03</span>
            <img src={policyguidanceimg} alt="Personalized Guidance Icon" className="step-icon" />
          </div>
          <h3 className="item-title">We Offer Personalized Guidance</h3>
          <p className="item-description">
            Talk to our Insurance Strategist — a 30-minute 1-on-1 session for just ₹99.
          </p>
        </div>
        <div className="process-item item-4">
          <div className="circle-container">
            <span className="step-number">04</span>
            <img src={policydecisionimg} alt="Informed Decision Icon" className="step-icon" />
          </div>
          <h3 className="item-title">You Take an Informed Decision</h3>
          <p className="item-description">
            Compare, analyze, and select the right insurance policy that fits your needs perfectly.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PolicyProcessSteps;